const normalizeJournal = (s = "") =>
  String(s)
    .toLowerCase()
    .replace(/\(.*?\)/g, "")
    .replace(/\s+/g, " ")
    .trim();

const JOURNAL_LOGO_MAP = {
  "strategic change": "/strategic_change_logo.jpg",
  "international journal of contemporary hospitality management": "/ijchm_logo.jpg",
  "notes and records": "/Notes and Records_the Royal Society_Journal of the History of Science_logo.jpg",
  "notes and records the royal society journal of the history of science":
    "/Notes and Records_the Royal Society_Journal of the History of Science_logo.jpg",

  "agriculture": "/agriculture_logo.webp",
  "agronomy": "/agronomy_logo.webp",
  "agricultural economics": "/ag_ec_logo.webp",

  "sustainability": "/sustainability_logo.png",
  "foods": "/foods_logo.webp",
  "discover sustainability": "/discover_sustainability_logo.webp",

  "knowledge management research & practice": "/kmrp_logo.jpg",
  "knowledge management research and practice": "/kmrp_logo.jpg",

  "marketing intelligence & planning": "/mip_logo.jpeg",
  "marketing intelligence and planning": "/mip_logo.jpeg",

  "heliyon": "/heliyon_logo.webp",
  "european journal of innovation management": "/ejim_logo.png",
  "european journal of innovation & management": "/ejim_logo.png",

  "zagadnienia ekonomiki rolnej / problems of agricultural economics":
    "/problems_of_agri_econ.jpg",
  "zagadnienia ekonomiki rolnej": "/problems_of_agri_econ.jpg",
  "problems of agricultural economics": "/problems_of_agri_econ.jpg",

  "journal of family business management": "/jfbm_logo.gif",
  "british food journal": "/bfj_logo.png",
  "businesses": "/businesses_logo.png",
  "journal of cleaner production": "/jcp_logo.webp",
  "business strategy and the environment": "/bse_logo.webp",
  "frontiers in sustainable food systems": "/fsfsl_logo.jpg",

  "journal of wine economics": "/journalofwineeconomics.png",
  "journal of wine research": "/journalofwineresearch.webp",
  "investigaciones turísticas": "/Investigaciones_Turísticas_logo.jpg",
  "wine economics and policy": "/wineeconomicsandpolicy.png",
  "wine economics & policy": "/wineeconomicsandpolicy.png",

  "international journal of wine business research": "/ijwbr.png",
  "international journal of wine business & research": "/ijwbr.png",
  "ijwbr": "/ijwbr.png",
  "wine business research": "/journalofwineresearch.webp",

  "international journal of theoretical and applied finance": "/ijtaf_logo.png",
  "journal of destination marketing & management": "/jdmm_logo.png",
  "journal of destination marketing and management": "/jdmm_logo.png",
};

export const JOURNAL_GENERIC_ICON = "/journal_generic.svg";

export const getJournalLogoPath = (journal) => {
  const key = normalizeJournal(journal);
  return JOURNAL_LOGO_MAP[key] || JOURNAL_GENERIC_ICON;
};

export default getJournalLogoPath;
